import { mapState } from "vuex";
import Regon from 'regon-js';
var validate = require('validate-vat');
import i18n from "./translations";
import { CountryListGus } from "./enums/CountriesAll";

export const currencyMixin = {
  computed: {
    ...mapState('currency', ['currency', 'ratio']),
    ...mapState("customers", ["customer"])
  },
  methods: {
    currencyDisplay(value, recalculate = true, changeCurrency = false) {
      const calculatedValue = recalculate ? value / this.ratio : value;
      const currentCurrency = changeCurrency ? "PLN" : this.currency;
      return new Intl.NumberFormat("pl-PL", {
        style: "currency",
        currency: currentCurrency,
        currencyDisplay: "code"
      }).format(calculatedValue);
    },
    countryDisplay(value) {
      // var key = _.findKey(CountryListGus, function(v) {
      //   return v === value;
      // });
      const country = CountryListGus.find(function (element) {
        return element.code == value;
      });
      if (i18n.locale === 'pl')
        return country.namepl;
      else
        return country.nameen;
    },
    validationVIES(customer) {
      let countryCode = customer.country
      let vat = customer.vat.substring(2);
      validate(countryCode, vat, function (err, validationInfo) {
        console.log(err);
        console.log(validationInfo);
      });
    },
    async validationGUS(customer) {
      const client = new Regon({
        key: 'f45c73a48aab4aa7b656', // Required for non-sandbox mode. Your API key
        sandbox: false, // Optional. Enables sandbox mode. Off by default
      });
      await client.login();
      const results = await client.search({
        nip: 1234567890,
      });

      // client.login().then(() => {
      //   const results = client.search({
      //     nip: 1234567890
      //   });
      //   console.log("Results", results);
      // })

      await client.logout();

      console.log('Results', results);

      //   let vat = customer.vat.substring(2);

      //   const regon = new Regon({ key: 'f45c73a48aab4aa7b656' });

      //   // const searchParameters: ParametryWyszukiwania = {
      //   //   Krs?: string,
      //   //   Krsy?: string[''],
      //   //   Nip?: string,
      //   //   Nipy?: string[''],
      //   //   Regon?: string,
      //   //   Regony14zn?: string[''],
      //   //   Regony9zn?: string['']
      //   // };
      // let re = regon.getCompanyData(searchParameters) // returns Promise
      //     .then( companyInfo => findByNip );
      // console.log(companyInfoByNip);
      // return companyInfoByNip;
    }
  }
}
